import React from "react";

const VaccinationProgress = () => {
  const total = 356;
  const data = [
    {
      label: "completed vaccinations",
      value: 28,
      percentage: ((28 / total) * 100).toFixed(1),
      color: "stroke-purple-500",
      legendColor: "bg-purple-500",
    },
    {
      label: "incomplete and due",
      value: 125,
      percentage: ((125 / total) * 100).toFixed(1),
      color: "stroke-blue-700",
      legendColor: "bg-blue-700",
    },
    {
      label: "incomplete and overdue",
      value: 178,
      percentage: ((178 / total) * 100).toFixed(1),
      color: "stroke-sky-400",
      legendColor: "bg-sky-400",
    },
    {
      label: "incomplete and not yet due",
      value: 25,
      percentage: ((25 / total) * 100).toFixed(1),
      color: "stroke-purple-300",
      legendColor: "bg-purple-300",
    },
  ];

  // Calculate the length of the arc path for the larger arc
  const arcLength = 142; // Updated for the new path length

  return (
    <div className="flex flex-col w-full h-[50%] items-center bg-gray-50 px-5 rounded-lg shadow-md text-[12px] pb-4">
      <div className="relative w-full h-48 flex items-center justify-center mt-0">
        <svg
          className="w-80 h-80"
          viewBox="0 0 100 50"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Background Arc */}
          <path
            d="M5 45 a45 45 0 0 1 90 0"
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="5"
          />
          {/* Segments */}
          {(() => {
            let startOffset = 0;
            return data.map((item, index) => {
              const segmentLength = (item.value / total) * arcLength;
              const currentOffset = startOffset;
              startOffset += segmentLength;
              return (
                <path
                  key={index}
                  d="M5 45 a45 45 0 0 1 90 0"
                  fill="none"
                  strokeWidth="5"
                  strokeDasharray={`${segmentLength} ${
                    arcLength - segmentLength
                  }`}
                  strokeDashoffset={`-${currentOffset}`}
                  className={item.color}
                />
              );
            });
          })()}
        </svg>
        {/* Center Total Value */}
        <div className="absolute inset-0 flex items-center justify-center -translate-y-2">
          <span className="text-[72px] font-bold text-gray-800 mt-8">
            {total}
          </span>
        </div>
      </div>

      {/* Legend */}
      <div className="w-full space-y-2 text-[12px]">
        {data.map((item, index) => (
          <div key={index} className="flex justify-between items-center">
            <div className="flex items-center space-x-2">
              <div className={`w-4 h-4 rounded-full ${item.legendColor}`}></div>
              <span className="text-gray-700 text-sm">{item.label}</span>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-700">{item.value}</span>
              <span className="text-sm text-gray-500">{item.percentage}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VaccinationProgress;
